<!-- eslint-disable max-len -->
<template>
<svg
    width="11" height="11" viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path d="M0 0H5.21456V5.21231H0V0ZM5.78544 0H11V5.21231H5.78544V0ZM0 5.78544H5.21456V11H0V5.78544ZM5.78544 5.78544H11V11H5.78544" fill="currentColor" />
</svg>
</template>
